import store from "@/store/index";

export interface AdministratorPlayersProfileMatchesListFormCreate {
  user_id: string | string[];
  organization_id: string;
  match_category_id: string;
  content: {
    date: string;
    fields: any;
  };
}

export class AdministratorPlayersProfileMatchesListFormCreate implements AdministratorPlayersProfileMatchesListFormCreate {
  user_id: string | string[];
  organization_id: string;
  match_category_id: string;
  content: {
    date: string;
    fields: any;
  };

  constructor() {
    this.user_id = "";
    this.organization_id = store.getters.getOrganizationMember.organization_id ?? "";
    this.match_category_id = "";
    this.content = {
      date: "",
      fields: [],
    };
  }
}